import {
  Box,
  Flex,
  IconButton,
  Image,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Text,
  VStack,
} from '@chakra-ui/react'
import { useAuth } from '@hb/react'
import {
  okToContactField,
  partnerContactMethodField,
  partnerEmailField,
  partnerNameField,
  partnerPhoneField,
} from '@hb/shared'
import { useCallback, useMemo } from 'react'
import { useProfile } from '../../../../contexts/user/ProfileContext'
import { useUpdateDoc } from '../../../../hooks/backend/useUpdateDoc'
import { EditableRow } from '../../../forms/Input'

export const PartnerPopover = () => {
  const {
    // selectedAssessment: { populated: selectedAssessment },
    user,
    patientRef,
    userId,
  } = useProfile()
  const { mergedPartnerInfo } = user ?? {}
  const { name, email, phone, okToContact, contactMethod } = mergedPartnerInfo ?? {}

  const { authUser } = useAuth()
  const uid = useMemo(() => authUser?.uid ?? null, [authUser])
  const shouldUpdateCorrections = useMemo(() => {
    if (!uid) return false
    if (uid === userId) return false
    return true
  }, [uid, userId])

  const updatePatient = useUpdateDoc('partner info')
  const getPath = useCallback(
    (field: string) => `partnerInfo.${shouldUpdateCorrections ? 'corrections' : 'data'}.${field}`,
    [shouldUpdateCorrections],
  )

  const getUpdateField = useCallback(
    (field: string) => (data: any) => updatePatient(patientRef, getPath(field), data),
    [getPath, updatePatient, patientRef],
  )

  return (
    <Box mr={2}>
      <Popover trigger="hover">
        <PopoverTrigger>
          <IconButton
            size="md"
            variant="ghost"
            opacity={mergedPartnerInfo?.name ? 1 : 0.35}
            _hover={{ bg: 'whiteAlpha.500' }}
            borderRadius="full"
            aria-label="Partner"
            icon={<Image src="/images/svg/family.svg" width="26px" opacity={0.5} />}
          />
        </PopoverTrigger>
        <PopoverContent width="375px">
          <PopoverBody p={0}>
            <Flex
              borderTopRadius={6}
              bg="gray.100"
              w="100%"
              flexDirection="column"
              py={1}
              px={3}
              borderBottom="1px solid #cdcdcd">
              <Text lineHeight="1.2" color="gray.600" fontWeight={600} fontSize="lg">
                Partner Info
              </Text>
            </Flex>
            <VStack spacing={0} width="100%">
              <EditableRow
                onSubmit={getUpdateField('name')}
                index={0}
                label="Partner Name"
                parentValue={mergedPartnerInfo}
                value={name}
                field={partnerNameField}
              />
              <EditableRow
                onSubmit={getUpdateField('email')}
                index={1}
                label="Partner Email"
                value={email}
                parentValue={mergedPartnerInfo}
                field={partnerEmailField}
              />
              <EditableRow
                onSubmit={getUpdateField('phone')}
                index={1}
                label="Partner Phone"
                value={phone}
                parentValue={mergedPartnerInfo}
                field={partnerPhoneField}
              />
              <EditableRow
                index={1}
                label="Ok to Contact"
                value={okToContact}
                parentValue={mergedPartnerInfo}
                field={okToContactField}
                onSubmit={getUpdateField('okToContact')}
              />
              {okToContact ? (
                <EditableRow
                  index={1}
                  label="Preferred Contact Method"
                  value={contactMethod}
                  parentValue={mergedPartnerInfo}
                  field={partnerContactMethodField}
                  onSubmit={getUpdateField('contactMethod')}
                />
              ) : null}
            </VStack>
          </PopoverBody>
          <PopoverArrow bg="gray.100" />
        </PopoverContent>
      </Popover>
    </Box>
  )
}
